export enum Address {
    MAIN = 1,
    MAILING = 2,
    BILLING = 3,
    VISITING = 4,
    PICKUP = 5,
}
